import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Box, Card, Link, Typography, Stack } from '@mui/material';
import { styled } from '@mui/system';
// utils
import { fCurrency } from '../../../utils/formatNumber';
//
import Label from '../../Label';
import ColorPreview from '../../ColorPreview';

// ----------------------------------------------------------------------

const LogoStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute'
});

// ----------------------------------------------------------------------

CandidateCard.propTypes = {
  candidate: PropTypes.object
};

export default function CandidateCard({ id, candidate }) {
  const { name, logo } = candidate;

  return (
    <Card>
      <Link underline="none" component={RouterLink} to={`/dashboard/candidates/${id}`}>
        <Box sx={{ pt: '100%', position: 'relative' }}>
          <LogoStyle alt={name} src={logo} />
        </Box>

        <Stack spacing={2} sx={{ p: 3 }}>
          <Typography variant="subtitle2" noWrap>
            {name}
          </Typography>
        </Stack>
      </Link>
    </Card>
  );
}
